import Header from "@/components/Header";
import Hero from "@/components/Hero";
import PartnersLogos from "@/components/PartnersLogos";
import { lazy, Suspense } from "react";

const TargetCards = lazy(() => import("@/components/TargetCards"));
const WhoWeAre = lazy(() => import("@/components/WhoWeAre"));
const Solutions = lazy(() => import("@/components/Solutions"));
const ServiceAreas = lazy(() => import("@/components/ServiceAreas"));
const HowWeWork = lazy(() => import("@/components/HowWeWork"));
const ProcessSteps = lazy(() => import("@/components/ProcessSteps"));
const ResultsNumbers = lazy(() => import("@/components/ResultsNumbers"));
const LGPDSection = lazy(() => import("@/components/LGPDSection"));
const AlertasGolpes = lazy(() => import("@/components/AlertasGolpes"));
const FAQ = lazy(() => import("@/components/FAQ"));
const WorkWithUs = lazy(() => import("@/components/WorkWithUs"));
const Contact = lazy(() => import("@/components/Contact"));
const CTA = lazy(() => import("@/components/CTA"));
const Footer = lazy(() => import("@/components/Footer"));
const FraudeAlert = lazy(() => import("@/components/FraudeAlert"));

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
      <Header />
      <Hero />
      <PartnersLogos />

      {/* Seção institucional */}
      <Suspense fallback={null}>
        <TargetCards />
        <WhoWeAre />
      </Suspense>

      {/* Soluções */}
      <Suspense fallback={null}>
        <Solutions />
        <ServiceAreas />
        <HowWeWork />
      </Suspense>

      {/* Processo e resultados */}
      <Suspense fallback={null}>
        <ProcessSteps />
        <ResultsNumbers />
      </Suspense>

      {/* Conteúdo legal / informativo */}
      <Suspense fallback={null}>
        <LGPDSection />
        <AlertasGolpes />
      </Suspense>

      {/* Conversão */}
      <Suspense fallback={null}>
        <FAQ />
        <WorkWithUs />
        <Contact />
        <CTA />
      </Suspense>

      {/* Footer */}
      <Suspense fallback={null}>
        <Footer />
      </Suspense>

      {/* Extra (pode até ser carregado depois) */}
      <Suspense fallback={null}>
        <FraudeAlert />
      </Suspense>
    </div>
  );
};

export default Index;
